export enum ServiceApprovalChannel {
  CREATE = 'serviceApproval::create',
  EDIT = 'serviceApproval::patch',
  DELETE = 'serviceApproval::delete',
}
